import Home from "../views/Home.vue";
const routes = [
    {
        path: "/login",
        name: "Login",
        meta: {
            title: '登录'
        },
        component: () => import ( /* webpackChunkName: "login" */ "../views/Login.vue")
    },
    {
        path: "/details",
        name: "details",
        meta: {
            title: '产品详情'
        },
        component: () => import ( /* webpackChunkName: "login" */ "../views/details.vue")
    },
    {
        path: "/demo",
        name: "demo",
        meta: {
            title: 'demo'
        },
        component: () => import ( /* webpackChunkName: "login" */ "../views/demo/index.vue")
    },
    {
        path: "/gateway",
        name: "gateway",
        meta: {
            title: 'gateway'
        },
        component: () => import ( /* webpackChunkName: "login" */ "../views/demo/gateway.vue")
    },
    {
        path: "/agreement-display",
        name: "agreement-display",
        meta: {
            title: 'App协议'
        },
        component: () => import ( /* webpackChunkName: "productAddEdit" */ "../views/agreement/display.vue")
    },
    {
        path: "/",
        name: "Home",
        component: Home,
        redirect:'/dashboard',
        children: [
            {
                path: "/user",
                name: "user",
                meta: {
                    title: '用户'
                },
                component: () => import ( /* webpackChunkName: "user" */ "../views/user/index.vue")
            }, {
                path: "/appUser",
                name: "appUser",
                meta: {
                    title: '用户'
                },
                component: () => import ( /* webpackChunkName: "user" */ "../views/appUser/index.vue")
            },{
                path: "/dashboard",
                name: "dashboard",
                meta: {
                    title: '首页',
                    tab: false, // 是否显示导航条
                },
                component: () => import ( /* webpackChunkName: "dashboard" */ "../views/Dashboard.vue")
            },{
                path: "/feedback",
                name: "feedback",
                meta: {
                    title: '反馈'
                },
                component: () => import ( /* webpackChunkName: "feedback" */ "../views/feedback/index.vue")
            },{
                path: "/setting",
                name: "setting",
                meta: {
                    title: '系统设置'
                },
                component: () => import ( /* webpackChunkName: "setting" */ "../views/setting/index.vue")
            },{
                path: "/logs",
                name: "logs",
                meta: {
                    title: '版本记录',
                    tab: false,
                },
                component: () => import ( /* webpackChunkName: "logs" */ "../views/logs/index.vue")
            },{
                path: "/role",
                name: "role",
                meta: {
                    title: '角色'
                },
                component: () => import ( /* webpackChunkName: "role" */ "../views/role/index.vue")
            },{
                path: "/menu",
                name: "menu",
                meta: {
                    title: '菜单'
                },
                component: () => import ( /* webpackChunkName: "menu" */ "../views/menu/index.vue")
            },{
                path: "/faq",
                name: "faq",
                meta: {
                    title: 'FAQ',

                },
                component: () => import ( /* webpackChunkName: "faq" */ "../views/faq/index.vue")
            },{
                path: "/faqAddEdit",
                name: "faqAddEdit",
                meta: {
                    title: 'FAQ添加编辑',
                    parent: {
                        fullPath: '/faq',
                        title: 'FAQ'

                    }

                },
                component: () => import ( /* webpackChunkName: "faqAddEdit" */ "../views/faq/addEdit.vue")
            },{
                path: "/product",
                name: "product",
                meta: {
                    title: '产品',
                    keepAlive:true,
                },
                component: () => import ( /* webpackChunkName: "product" */ "../views/product/index.vue")
            },{
                path: "/productAddEdit",
                name: "productAddEdit",
                meta: {
                    title: '产品添加编辑',
                    parent: {
                        fullPath: '/product',
                        title: '产品'

                    }
                },
                component: () => import ( /* webpackChunkName: "productAddEdit" */ "../views/product/addEdit.vue")
            },
            {
                path: "/app",
                name: "app",
                meta: {
                    title: 'App管理'
                },
                component: () => import ( /* webpackChunkName: "productAddEdit" */ "../views/app/index.vue")
            },
            {
                path: "/agreement",
                name: "agreement",
                meta: {
                    title: '用户协议管理'
                },
                component: () => import ( /* webpackChunkName: "productAddEdit" */ "../views/agreement/index.vue")
            },
            {
                path: "/agreement-edit",
                name: "agreement-edit",
                meta: {
                    title: '用户协议编辑',
                    parent: {
                        fullPath: '/agreement',
                        title: '用户协议管理'

                    }
                },
                component: () => import ( /* webpackChunkName: "productAddEdit" */ "../views/agreement/edit.vue")
            }
        ]
    }
];
export default routes
